import store from '@/store'

const BASE_URL_REGISTER_SPONSOR = `/sponsor/register`
const BASE_URL_UPDATE_SPONSOR = `/sponsor/update`

const BASE_URL_REGISTER_PROVIDER = `/provider/register`
const BASE_URL_UPDATE_PROVIDER = `/provider/update`
const BASE_URL_MANAGER = `/provider`

const BASE_URL_REGISTER_BUYER = `/buyer/register`
const BASE_URL_UPDATE_BUYER = `/buyer/update`
const BASE_URL_BUYER = `/buyer`


const registerStepRoutes = () => ({
    update: {
        companyType: [
            {
                0: `${BASE_URL_UPDATE_SPONSOR}/${store.state.register.company.cnpjId}/0`,
                1: `${BASE_URL_UPDATE_SPONSOR}/${store.state.register.company.cnpjId}/1`,
                2: `${BASE_URL_UPDATE_SPONSOR}/${store.state.register.company.cnpjId}/2`,
                3: `${BASE_URL_UPDATE_SPONSOR}/${store.state.register.company.cnpjId}/3`,
                4: `${BASE_URL_UPDATE_SPONSOR}/${store.state.register.company.cnpjId}/4`,
                partner: `${BASE_URL_UPDATE_SPONSOR}/${store.state.register.company.cnpjId}/partner`
            },
            {
                0: `${BASE_URL_UPDATE_PROVIDER}/${store.state.register.company.cnpjId}/0`,
                1: `${BASE_URL_UPDATE_PROVIDER}/${store.state.register.company.cnpjId}/1`,
                2: `${BASE_URL_UPDATE_PROVIDER}/${store.state.register.company.cnpjId}/2`,
                3: `${BASE_URL_UPDATE_PROVIDER}/${store.state.register.company.cnpjId}/3`,
                4: `${BASE_URL_UPDATE_PROVIDER}/${store.state.register.company.cnpjId}/4`,
                5: `/partner/${store.state.register.company.cnpjId}`,
                users: `${BASE_URL_MANAGER}/${store.state.register.company.cnpjId}/users`,
                groups: `${BASE_URL_MANAGER}/${store.state.register.company.cnpjId}/groups`,
                contract: `${BASE_URL_MANAGER}/${store.state.register.company.cnpjId}/contract`,
            },
            {
                0: `${BASE_URL_UPDATE_BUYER}/${store.state.register.company.cnpjId}/0`,
                1: `${BASE_URL_UPDATE_BUYER}/${store.state.register.company.cnpjId}/1`,
                2: `${BASE_URL_UPDATE_BUYER}/${store.state.register.company.cnpjId}/2`,
                3: `${BASE_URL_UPDATE_BUYER}/${store.state.register.company.cnpjId}/3`,
                4: `${BASE_URL_UPDATE_BUYER}/${store.state.register.company.cnpjId}/4`,
                contract: `${BASE_URL_BUYER}/${store.state.register.company.cnpjId}/contract`,
            },
        ]
    },
    register: {
        companyType: [
            {
                0: `${BASE_URL_REGISTER_SPONSOR}/${store.state.register.company.cnpjId}/0`,
                1: `${BASE_URL_REGISTER_SPONSOR}/${store.state.register.company.cnpjId}/1`,
                2: `${BASE_URL_REGISTER_SPONSOR}/${store.state.register.company.cnpjId}/2`,
                3: `${BASE_URL_REGISTER_SPONSOR}/${store.state.register.company.cnpjId}/3`,
                4: `${BASE_URL_REGISTER_SPONSOR}/${store.state.register.company.cnpjId}/4`,
                partner: `${BASE_URL_REGISTER_SPONSOR}/${store.state.register.company.cnpjId}/partner`
            },
            {
                0: `${BASE_URL_REGISTER_PROVIDER}/${store.state.register.company.cnpjId}/0`,
                1: `${BASE_URL_REGISTER_PROVIDER}/${store.state.register.company.cnpjId}/1`,
                2: `${BASE_URL_REGISTER_PROVIDER}/${store.state.register.company.cnpjId}/2`,
                3: `${BASE_URL_REGISTER_PROVIDER}/${store.state.register.company.cnpjId}/3`,
                4: `${BASE_URL_REGISTER_PROVIDER}/${store.state.register.company.cnpjId}/4`,
                5: `/partner/${store.state.register.company.cnpjId}`,
                users: `${BASE_URL_MANAGER}/${store.state.register.company.cnpjId}/users`,
                groups: `${BASE_URL_MANAGER}/${store.state.register.company.cnpjId}/groups`,
                contract: `${BASE_URL_MANAGER}/${store.state.register.company.cnpjId}/contract`,
            },
            {
                0: `${BASE_URL_REGISTER_BUYER}/${store.state.register.company.cnpjId}/0`,
                1: `${BASE_URL_REGISTER_BUYER}/${store.state.register.company.cnpjId}/1`,
                2: `${BASE_URL_REGISTER_BUYER}/${store.state.register.company.cnpjId}/2`,
                3: `${BASE_URL_REGISTER_BUYER}/${store.state.register.company.cnpjId}/3`,
                4: `${BASE_URL_REGISTER_BUYER}/${store.state.register.company.cnpjId}/4`,
                contract: `${BASE_URL_BUYER}/${store.state.register.company.cnpjId}/contract`,
            },
        ]

    },   
})

export default registerStepRoutes